import { render, staticRenderFns } from "./LogoDevelop.vue?vue&type=template&id=4787792b"
import script from "./LogoDevelop.vue?vue&type=script&lang=js"
export * from "./LogoDevelop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports